import { format } from 'd3-format';
var formatter = format('.2s');
export var formatNumber = function (value) { return formatter(value); };
